import { IBBoxSchema } from '../../../../node/types/bbox';
import { EMapBoundsActionType } from '../../../common/actions/mapBounds';
import { IApplicationState, TReduxActions } from '../../../common/types/redux';
import { bboxToMapBounds } from '../../../common/utils/mapBounds';
import { EFetchMapDataActionType } from '../../actions';
import { TMapBounds } from '../../types/mapBounds';

const initialState: IApplicationState['map']['mapBounds'] = {
  center: [0, 0],
  zoom: 0,
  precision: 0,
  bounds: [
    [0, 0],
    [0, 0],
  ],
};

export function mapBoundsReducer(
  state: IApplicationState['map']['mapBounds'] = initialState,
  action: TReduxActions,
): IApplicationState['map']['mapBounds'] {
  switch (action.type) {
    case EFetchMapDataActionType.Succeed: {
      if (!action.payload.updateBounds) {
        return state;
      }

      /**
       * Остальные значения будут получены при следующей перерисовке
       * @see {@link MapBoundsUpdater}
       */
      return bboxToMapBounds(action.payload.bbox as IBBoxSchema) as TMapBounds;
    }

    case EMapBoundsActionType.Changed:
      return action.payload;
  }

  return state;
}
